module.exports = __webpack_public_path__ + "img/4Y.ca06945a.png";